/* eslint-disable react-hooks/exhaustive-deps */
import FieldName from '../utils/FieldName';
import Space from '@/components/Space';
import TextEditor from '../utils/TextEditor';
import useSetCurrentFieldValue from '../utils/useSetCurrentFieldValue';
import useCurrentFieldValue from '../utils/useCurrentFieldValue';
import { useCallback } from 'react';

type TextFieldEditorProps = {
  onClose: () => void;
};

const TextFieldEditor = ({ onClose }: TextFieldEditorProps) => {
  const initialValue = useCurrentFieldValue<string>(
    '',
    value => typeof value === 'string',
  );
  const [setCurrentFieldValue, saving] = useSetCurrentFieldValue<
    string | null
  >();

  const handleSave = useCallback(
    async (value: string | null): Promise<void> => {
      // no-op
      if (initialValue === '' && value === null) {
        onClose();

        return;
      }

      await setCurrentFieldValue(value);

      onClose();
    },
    [initialValue],
  );

  return (
    <>
      <FieldName />
      <Space height={12} />
      <TextEditor
        initialValue={initialValue.toString()}
        onSave={handleSave}
        disabled={saving}
      />
    </>
  );
};

export default TextFieldEditor;
